import Region from '@/services/api/region';

export default {
  namespaced: true,
  state: {
    regions: [],
    region: null,
  },
  getters: {
    regions: state => state.regions,
    region: state => state.region,
  },
  mutations: {
    setRegions: (state, payload) => {
      state.regions = payload;
    },
    setRegion: (state, payload) => {
      state.region = payload;
    },
  },
  actions: {
    getRegions (state) {
      Region.getRegions()
        .then(({ data }) => {
          state.commit('setRegions', data.regions);
        })
        .catch(e => console.error(e));
    },
    getRegion (state, id) {
      return new Promise((resolve, reject) => {
        Region.getRegion(id)
          .then(({ data }) => {
            state.commit('setRegion', data.region);
            resolve(data.region);
          })
          .catch(e => reject(e));
      });
    },
  },
};
